import { Component } from '@angular/core';
import { AmplitudeService } from './services/external-tools/amplitude.service';
import { SplitIoService } from './services/external-tools/split-io.service';
import { TranslocoService } from '@jsverse/transloco';
import { TranslationService } from './services/translation.service';
import { Title } from '@angular/platform-browser';
import { take } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  constructor(
    private amplitudeService: AmplitudeService,
    private splitService: SplitIoService,
    private translocoService: TranslocoService,
    private translationService: TranslationService,
    private titleService: Title
  ) {
    this.translocoService.langChanges$.subscribe((lang) => {
      document.documentElement.lang = lang;
      // this.setTranslatedTitle();
    });
  }

  async ngOnInit() {
    await this.translationService.loadScopedTranslation('root');

     window.addEventListener('pageshow', (event: PageTransitionEvent) => {
      const navEntry = performance.getEntriesByType(
        'navigation'
      )[0] as PerformanceNavigationTiming | undefined;
      const isBackForward =
        (event.persisted ?? false) ||
        navEntry?.type === 'back_forward';
      if (isBackForward) {
        document.documentElement.style.display = 'none';
        window.location.replace('/login');
      }
    });

    // Initialize Amplitude here when the app starts
    this.amplitudeService.initAmplitude();

    // Initialize Split.io here when the app starts
    this.splitService.initSplit();
  }

  // setTranslatedTitle() {
  //   this.translocoService
  //     .selectTranslate('QUANTIFIED_AI', {}, '')
  //     .pipe(take(1))
  //     .subscribe(val => {
  //       this.titleService.setTitle(val);
  //     });
  // }
}
